import { planApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';
import { CreateTrainingPlan, UpdatePlanAndNotifyDTO } from '@/generated';

const refreshChannel = new BroadcastChannel('plans-refresh');

export const useUpdatePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updatePlanAndNotifyDTO: UpdatePlanAndNotifyDTO) => planApi.planUpdatePlanWithEmail({ updatePlanAndNotifyDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.Plans] });
      queryClient.invalidateQueries({ queryKey: [queryKeys.Plan, dto.plan.id] });

      refreshChannel.postMessage('refresh');
    },
  });
};

export const useCreatePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createPlanDTO: CreateTrainingPlan) => planApi.planCreatePlan({ createTrainingPlan: createPlanDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.Plans] });

      refreshChannel.postMessage('refresh');
    },
  });
};

export const useDeletePlan = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => planApi.planDeletePlan({ planId: id }),
    onSuccess: (_, id) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.Plans] });
      queryClient.invalidateQueries({ queryKey: [queryKeys.Plan, id] });

      refreshChannel.postMessage('refresh');
    },
  });
};
